import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { array, func } from 'prop-types';
import FlowPixel from './FlowPixel';
import CustomControl from '../CustomControl/CustomControl';

class FlowPixels extends PureComponent {
  static propTypes = {
    pixels: array.isRequired,
    selected: array.isRequired,
    onPixelChange: func.isRequired,
  };

  static defaultProps = {
    pixels: [],
    selected: [],
  };

  state = {
    checkedAll: true,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { pixels = [], selected = [] } = nextProps;

    if(selected.length > 0 && this.state.checkedAll) {
      this.setState(() => ({ checkedAll: false }));
    }
    if (pixels.length > 0 && selected.length === pixels.length) {
      this.setState(() => ({ checkedAll: true }), () => this.props.onPixelChange([]));
    }
  }

  isSelected = id => {
    const { selected } = this.props;
    return selected.indexOf(id) > -1;
  };

  handleChange = ({ target }) => {
    const id = parseInt(target.value, 10);
    const { selected } = this.props;

    if (selected.includes(id)) {
      this.props.onPixelChange(selected.filter(status => status !== id));
    } else {
      this.props.onPixelChange([...selected, id]);
    }
  };

  toggleCheckAll = () => {
    const { pixels } = this.props;

    this.setState(
      prevState => ({
        checkedAll: !prevState.checkedAll,
      }),
      () => {
        if (this.state.checkedAll) {
          this.props.onPixelChange(pixels.map(({ id }) => id));
        } else {
          this.props.onPixelChange([]);
        }
      });
  };

  render() {
    const { pixels } = this.props;
    const { checkedAll } = this.state;

    return (
      <div className="flow-pixels">
        <CustomControl
          id="pixel-all"
          className="custom-control-xs pixel-list-item"
          value="all"
          onChange={this.toggleCheckAll}
          checked={checkedAll}
        >
          <FormattedMessage
            id="flow.form.postback.all-pixels"
            defaultMessage="Postback for all goals"
          />
        </CustomControl>

        {!checkedAll && (
          <ul className="pixels-list">
            {pixels.map(({ id, title }) => (
              <FlowPixel
                key={id}
                id={id}
                label={title}
                value={id}
                checked={this.isSelected(id)}
                onChange={this.handleChange}
              />
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default FlowPixels;
